export default __webpack_public_path__ + "static/media/introImage4-min.05af1b36.png";